import moment from "moment";

export default (value, format = null, limitDays = 30) => {
    try {
        return moment(value).calendar(null, {
            lastWeek: 'd [days ago]',
            lastDay: '[Yesterday]',
            sameDay: '[Today]',
            nextDay: '[Tomorrow]',
            nextWeek: 'dddd',
            sameElse: () => {
                let diffDays = moment().diff(value, 'days');
                if (diffDays <= limitDays) {
                    return `[${diffDays} days ago]`;
                } else {
                    let formatDate = format ? moment(value).format(format) : value;
                    return `[${formatDate}]`;
                }
            }
        });
    } catch (err) {
        console.log('KS-APP: ', err);
        return null;
    }
}
